import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Accordion, Card, ListGroup } from "react-bootstrap";
import {
  SHIPPING,
  VENDORPLATFORM_SUB_HEAD_LOCATIONDETAILS,
  VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS
} from "../../../../constants/Constants";
import CircleProgress from "../../../VendorOnboarding/Views/RoundProgressBar/RoundProgressBar";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import "./ShippingLeftSideNav.css";
import "../../../../assets/css/Common.css";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { updateLeftNav } from "../../../../redux/leftNavSlice";
import {
  VENDORPLATFORM_VENDORONBOARDING_LEFTSIDENAV,
  VMP_ONBOARDING_STATUS,
  VIEW,
  ALL,
  NONE,
} from "../../../../constants/RolePermissionConstants";
import { shippingAccordion } from "./ShippingLinkItemValues";
import { updateServiceData } from "../../../../redux/serviceSlice";

const ShippingLeftSideNav = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { step, type = SHIPPING } = props.params;
  const pageID = step || type;
  const pathname = history.location?.pathname || '';
  const store = useSelector(
    (state) => ({
      boardingStatuses: state.common.boardingStatuses,
      percentCompletion: state.service.vendorStatus[0]?.percentCompletion,
      profileId: state.common.profileId,
      duns: state.common.duns,
      vendorCorpName: state.common.vendorCorpName,
      vendorConnectionPlatform: state.common.vendorConnectionPlatform,
      primaryContact: state.leftNav.primaryContact,
      activeAccordionKey: state.leftNav.activeAccordionKey || "0",
      selectedSection:
        state.leftNav.selectedSection ||
        (pathname.includes("routing")  ?
          VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS :
        VENDORPLATFORM_SUB_HEAD_LOCATIONDETAILS),
      profileTypeDetails: state.service.vendorProfile?.profileTypeDetails,
      workflowSteps: state.service.workflowSteps,
      merchandiseType:
        state.service.vendorProfile?.vendorDetail?.merchandiseType || "",
      hierarchyDetails:
        state.service.vendorProfile?.vendorDetail?.hierarchyDetails || [],
      vendorMenuItems: state.common.vendorMenuItems || [],
    }),
    shallowEqual
  );

  const onToggleHandler = ({ activeAccordionKey, selectedSection }) => {
    dispatch(
      updateLeftNav({
        selectedSection,
        activeAccordionKey,
      })
    );
  };

  const renderListItem = (info) => {
    const { linkInfo, eventKey, accordionName } = info;
    return (
      <Card style={{ width: "100%", paddingLeft: 10 }}>
        <Accordion.Toggle
          as={Card.Header}
          variant="link"
          eventKey={eventKey}
          className={`d-flex w-100 justify-content-between align-items-center 
              ${
                store.activeAccordionKey === eventKey
                  ? "accordianColorActive"
                  : "accordianColor"
              }`}
          onClick={(e) =>
            onToggleHandler({
              activeAccordionKey:
                store.activeAccordionKey === eventKey ? "" : eventKey,
              selectedSection: store.selectedSection,
            })
          }
          id={accordionName}
        >
          {accordionName}
          <span
            className={
              store.activeAccordionKey === eventKey
                ? "down-arrow-img"
                : "right-arrow-img"
            }
          ></span>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={eventKey}>
          <ListGroup variant="flush">
            {linkInfo.map(({ id, path, linkName, pageRoleId }, idx) => {
              const routeSubstr = path(store.profileId).split("/");

              const selected = store.selectedSection === linkName;
              if (!store.selectedSection && routeSubstr[3] === pageID) {
                onToggleHandler({
                  activeAccordionKey: eventKey,
                  selectedSection: linkName,
                });
              }
              let listItem = (
                <ListGroup.Item
                  className="d-flex w-100 justify-content-between align-items-center"
                  key={idx + "_leftNav_listGroup"}
                >
                  <Link
                    style={selected ? { fontWeight: 600, fontSize: 15 } : {}}
                    to={path(store.profileId)}
                    onClick={() => {
                      dispatch(updateServiceData({ fetching: true }));
                      onToggleHandler({
                        activeAccordionKey: store.activeAccordionKey,
                        selectedSection: linkName,
                      });
                    }}
                    key={idx + "_leftNav_link"}
                  >
                    {linkName}
                  </Link>
                </ListGroup.Item>
              );
              return listItem;
            })}
          </ListGroup>
        </Accordion.Collapse>
      </Card>
    );
  };

  return (
    <div
      className="navMarginNoneMerApp flex-column nav-pills"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <Card style={{ width: "100%", paddingLeft: 10 }}>
        <Card.Title className="align-items-center card-title-ma">
          <div className="leftSideNavCardTitleContainer">
            <div className="leftSideNavCardTitle">
              <div className="fs-14 leftSideNavVendorCorpName">
                {store.vendorCorpName || null}
              </div>

              {getUserRolePermission(
                VENDORPLATFORM_VENDORONBOARDING_LEFTSIDENAV,
                VMP_ONBOARDING_STATUS
              ) === VIEW && (
                <div className="fs-14 leftSideNavOnboardingStatus">
                  {store.boardingStatuses?.onboardingStatus}
                </div>
              )}
            </div>
            <div className="leftSideNavCircleProgress">
              <CircleProgress percent={store.percentCompletion || 0} />
            </div>
          </div>
        </Card.Title>
        <div className="card-text-ma">
          <div>
            <div className="lh-1 fs-12 m-top-10">
              <p className="mt-4">
                <span className="bold">DUNS: </span>
                {store.duns}
              </p>
              <p>
                <span className="ma-top-div-phone"></span>
                {store.primaryContact.vendorPhone}
              </p>
              <p>
                <span className="ma-top-div-email"></span>
                {store.primaryContact.userEmail}
              </p>
              <span className="ma-top-div-loc"></span>

              <p className="contactText">
                {store.primaryContact.streetAddress
                  ? `${store.primaryContact.streetAddress},`
                  : ""}
                <br />
                <span>
                  {store.primaryContact.city
                    ? `${store.primaryContact.city},`
                    : ""}{" "}
                  {store.primaryContact.state
                    ? `${store.primaryContact.state},`
                    : ""}{" "}
                  {store.primaryContact.zipCode
                    ? `${store.primaryContact.zipCode},`
                    : ""}
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>

      <Accordion activeKey={store.activeAccordionKey} id="accordian-merch-app">
        {renderListItem(shippingAccordion)}
      </Accordion>
    </div>
  );
};

export default ShippingLeftSideNav;
